import { DOCUMENT } from 'global/constants';
import {
  StimulusLibrary,
  StimulusLibraryCreate,
} from '../shared/stimulus-library';
import DocumentEditDrawer from './document-edit-drawer';
import { EditProps } from './document.constants';

const DocumentSettings = (props: EditProps) => {
  return props.properties.stimulusId ? (
    <DocumentEditDrawer title="Document" {...props} />
  ) : (
    <StimulusLibrary
      stimulusType={DOCUMENT}
      componentId={props.id}
      title="Document"
      canGoBack={false}
      headerActionButton={
        <StimulusLibraryCreate
          sectionId={props.sectionId}
          componentId={props.id}
          contentId={props.lessonId}
          type={DOCUMENT}
        />
      }
      {...props}
    />
  );
};

export default DocumentSettings;
